import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';
import { mixins } from '@styles/mixins';

export const LinkItem = styled.li(({ theme }: ThemeProps) => ({
  ...mixins(theme).link,
  ...(theme.custom.typography.h5 as any),
  fontWeight: 'normal',
  textWrap: 'wrap'
}));
